module.exports = __webpack_public_path__ + "media/assets/faria_products/CAM-IGCSE-7392100097defac68f2ea18fe936a60eebdb72580f2d093d6be42bb0b4be804e.png";